import { Header } from "../components/Header"
import { SlBasket } from "react-icons/sl";
import { BsGrid } from "react-icons/bs";
import { BsCake } from "react-icons/bs";
import { GiSwordwoman } from "react-icons/gi";
import { GiBowman } from "react-icons/gi";
import { TbVip } from "react-icons/tb";
import ps2 from '../assets/images/store/ps2.png';
import products from '../database/products.json';

import confirmationWallpaper from '../assets/images/confirmationWallpaper.png';
import { ReactNode, useEffect, useState } from "react";
import { Product } from "../@types/Product";

export const Store = () => {

    const [produtos, setProdutos] = useState<Product[]>([]);

    useEffect(() => {
        setProdutos(products.produtos as Product[]);
    }, []);

    return (
        <>
            <Header />
            <section className="flex py-8 flex items-center justify-between px-12">
                <h2 className="amatic-sc-bold text-4xl">Bem-Vindo a F&L Store</h2>
                <div className="flex items-center gap-1 relative">
                    <SlBasket className="text-3xl"/>
                    <span className="p-1 bg-emerald-900 rounded-full text-white w-8 h-8 flex self-start items-center justify-center">+9</span>
                </div>
            </section>
            <div className="bg-gray-300 mx-12 h-60 rounded-lg bg-cover bg-center relative" style={{ backgroundImage: `url(${confirmationWallpaper})` }}>
                <div className="overlay bg-black w-full h-full absolute opacity-30 rounded-lg"></div>
            </div>
            <div className="py-4 mx-12">
                <nav className="flex gap-6">
                    <ButtonCategory icon={<BsGrid />} description="Todos" isSelected={true}/>
                    <ButtonCategory icon={<GiBowman />} description="Noivo" isSelected={false}/>
                    <ButtonCategory icon={<GiSwordwoman />} description="Noiva" isSelected={false}/>
                    <ButtonCategory icon={<TbVip />} description="Serviços" isSelected={false}/>
                    <ButtonCategory icon={<BsCake />} description="Festa" isSelected={false}/>
                </nav>
            </div>
            <div className="mx-12 py-4 flex flex-wrap justify-evenly">
                {produtos.map((produto) => <ProductBox imageSrc={ps2} name={produto.name} description={produto.description} price={produto.price}/>)}
            </div>
        </>
    )
}

type ButtonProps = {
    icon: ReactNode;
    description: string;
    isSelected: boolean;
}

const ButtonCategory = ({icon, description, isSelected}: ButtonProps) => {
    const [selected, setSelected] = useState(isSelected);

    const selectStyle = selected ? 'bg-emerald-900 text-white font-bold poppins-bold' : 'border-2 border-emerald-900 text-emerald-900 poppins-regular';

    return (
        <button className={`flex ${selectStyle} items-center gap-2 p-2 rounded-md `}>
            {icon} {description}
        </button>
    )
}


type ProductProps = {
    imageSrc: string;
    name: string;
    description?: string;
    price: number;
}

const ProductBox = ({imageSrc, name, description, price}: ProductProps) => {

    return (
      <div className="max-w-sm mb-4 bg-gray-200 p-6 rounded-xl pb-2 relative">
        <div className="flex justify-center">
          <img className="block w-2/3" src={imageSrc} alt="" />
        </div>

        <div className="flex flex-col h-36 justify-between">
            <div>
                <h3 className="poppins-bold text-2xl">{name}</h3>
                <p className="poppins-light text-sm">
                {description}
                </p>
            </div>

            <div className="flex justify-between items-center pt-2">
                <button className="bg-white text-black w-10 h-10 flex justify-center items-center rounded-full text-2xl"><SlBasket /></button>
                <h4>R$ <span className="text-2xl poppins-regular">{price}</span>,99</h4>
            </div>
        </div>
      </div>
    );
}